import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import IconButton from '@mui/material/IconButton';
import HelpButton from 'app/shared-components/controls/HelpButton';


function TitledPanel({title, returnPath, onClose, children, onHelpClick}) {

  return (
      <div className="relative flex flex-col flex-auto items-center px-24 sm:px-48">
        <div className="flex flex-row items-center justify-between border-b-1 w-full py-16 mb-16">
          <div className="flex flex-grow">
            <Typography
	          component={motion.span}
	          initial={{ x: -20 }}
	          animate={{ x: 0, transition: { delay: 0.2 } }}
	          delay={300}
	          className="text-24 md:text-32 font-extrabold tracking-tight leading-none"
	        >
	          {title}
	        </Typography>
	      </div>
	       {onHelpClick &&
	        <div className="flex">
            <HelpButton onClick={onHelpClick} />
          </div>
          }
	      {returnPath && 
	        <div className="flex">
            <IconButton className="" component={NavLinkAdapter} to={returnPath} size="large">
              <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
            </IconButton>
          </div>
          }
        {onClose && !returnPath &&
	        <div className="flex">
            <IconButton className="" onClick={onClose} size="large">
              <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
            </IconButton>
          </div>
          }
        </div>
        
        {children}    
          				 
      </div>
      
  );
}

export default TitledPanel;
